import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration, TeamsService } from '../../api-client';
import { map, Observable, tap } from 'rxjs';
import { Team } from '../../models/team';

@Injectable({
  providedIn: 'root',
})
export class TeamService extends TeamsService {
  teams: Team[] = [];

  constructor(httpClient: HttpClient, config: Configuration) {
    super(httpClient, config.basePath!, config);
    this.getAll().subscribe();
  }

  getAll(): Observable<Team[]> {
    return super.getTeamsEndpoint().pipe(
      map((teams: Team[]) =>
        teams.map((team, index) => ({
          ...team,
          id: index,
        }))
      ),
      tap((teams: Team[]) => {
        this.teams = teams;
      })
    );
  }
}
